import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

export function useProfessionals(search: string) {
  return useQuery(allocationQueries.professionals(search));
}

/** Select de Profissional da tela Multialocados: só quem tem 2+ alocações vigentes. */
export function useMultiAllocatedProfessionals(search: string) {
  return useQuery(allocationQueries.professionals(search, true));
}
